"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeaderRowCount = exports.getFlatColumns = void 0;
exports.getLeafColumns = getLeafColumns;
exports.getMergedColumns = getMergedColumns;
exports.getOriginalColumns = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _getMergeRanges = function getMergeRanges(filteredCols) {
  return filteredCols === null || filteredCols === void 0 ? void 0 : filteredCols.map(function (column) {
    if (column.children) {
      var children = _getMergeRanges(column.children);
      var sum = 0;
      var max = 1;
      children.forEach(function (element) {
        sum += element.colSpan;
        max = Math.max(max, element.rowDepth);
      });
      return _objectSpread(_objectSpread({}, column), {}, {
        children: children,
        colSpan: sum,
        rowDepth: max + 1
      });
    }
    return _objectSpread(_objectSpread({}, column), {}, {
      rowDepth: 1,
      colSpan: 1
    });
  });
};
var _getMergeIndexes = function getMergeIndexes(filteredCols, columnLevel, rowLevel, depth) {
  return filteredCols === null || filteredCols === void 0 ? void 0 : filteredCols.forEach(function (column, index) {
    var _filteredCols;
    var startCol = index === 0 ? columnLevel : (_filteredCols = filteredCols[index - 1]) === null || _filteredCols === void 0 ? void 0 : _filteredCols.endColumn;
    column.startColumn = startCol + 1;
    column.endColumn = startCol + column.colSpan;
    if (column.children) {
      _getMergeIndexes(column.children, startCol, rowLevel + 1, depth);
      column.startRow = rowLevel + 1;
      column.endRow = rowLevel + 1;
    } else {
      column.startRow = rowLevel + 1;
      column.endRow = depth;
    }
  });
};
var initializeArray = function initializeArray(rows, cols) {
  return (0, _toConsumableArray2.default)(Array(rows)).map(function () {
    return Array(cols).fill(null);
  });
};
var getHeaderArray = function getHeaderArray(originalCols, headerRowCount, colDepth) {
  var result = initializeArray(headerRowCount, colDepth);
  var _fillArray = function fillArray(columns) {
    columns === null || columns === void 0 ? void 0 : columns.forEach(function (column) {
      if (column.children) {
        _fillArray(column.children);
      }
      result[column.startRow - 1][column.startColumn - 1] = column;
    });
  };
  _fillArray(originalCols);
  return result;
};
function getLeafColumns(columns) {
  var results = [];
  var _filterColumns = function filterColumns(items) {
    items === null || items === void 0 ? void 0 : items.forEach(function (item) {
      if (item.children) {
        _filterColumns(item.children);
      } else {
        results.push(item);
      }
    });
  };
  _filterColumns(columns);
  return results;
}
function getMergedColumns(columns) {
  var results = [];
  var _filterColumns2 = function filterColumns(items) {
    items === null || items === void 0 ? void 0 : items.forEach(function (item) {
      if (!item) {
        return;
      }
      if (item.children) {
        _filterColumns2(item.children);
      }
      var children = item.children,
        rest = (0, _objectWithoutProperties2.default)(item, _excluded);
      results.push(rest);
    });
  };
  _filterColumns2(columns);
  return results;
}
var getOriginalColumns = exports.getOriginalColumns = function getOriginalColumns(filteredCols) {
  var ranges = _getMergeRanges(filteredCols);
  var headerRowCount = getHeaderRowCount(ranges);
  if (!headerRowCount || headerRowCount <= 1) {
    return ranges;
  }
  _getMergeIndexes(ranges, 0, 0, headerRowCount);
  return ranges;
};
var getFlatColumns = exports.getFlatColumns = function getFlatColumns(originalCols, headerRowCount) {
  var _originalCols;
  if (!headerRowCount || headerRowCount <= 1) {
    return [originalCols];
  }
  var colDepth = (_originalCols = originalCols[originalCols.length - 1]) === null || _originalCols === void 0 ? void 0 : _originalCols.endColumn;
  return getHeaderArray(originalCols, headerRowCount, colDepth);
};
var getHeaderRowCount = exports.getHeaderRowCount = function getHeaderRowCount(originalCols) {
  if (!Array.isArray(originalCols)) {
    return 1;
  }
  return Math.max.apply(Math, [1].concat((0, _toConsumableArray2.default)(originalCols.map(function (column) {
    return column.rowDepth;
  })))) || 1;
};